import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { useGetIncomingVehicleIdsMutation } from '../../../api/compoundManagementApi';
import { compoundManagementSlice, getIncomingVehicleBulkSelection } from '../../../reducers/compoundManagementSlice';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { FIXED_INCOMING_CACHE_KEY } from './IncomingVehicleBulkSelectionDropdown';

export const CONTENT_LOADER_TEST_ID = 'inventory-selection-cell-loader';

type SelectionCellProps = {
    vehicleId: string;
};

export const IncomingSelectionCell = ({ vehicleId }: SelectionCellProps) => {
    const isSelected = useAppSelector((state) => getIncomingVehicleBulkSelection(state).includes(vehicleId));
    const dispatch = useAppDispatch();
    const [, { isLoading }] = useGetIncomingVehicleIdsMutation({ fixedCacheKey: FIXED_INCOMING_CACHE_KEY });

    const onSelect = () => {
        if (isSelected) {
            dispatch(compoundManagementSlice.actions.removeFromIncomingBulkSelection([vehicleId]));
        } else {
            dispatch(compoundManagementSlice.actions.addToIncomingBulkSelection([vehicleId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove vehicle from selection' : 'Add vehicle to selection';

    return (
        <td className="table-checkbox">
            {isLoading ? (
                <ContentLoader data-testid={CONTENT_LOADER_TEST_ID} />
            ) : (
                <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
            )}
        </td>
    );
};
